module.exports = __webpack_public_path__ + "img/invoices.d7ec02d6.svg";